import { Component, OnInit, Inject, Input } from '@angular/core';
import { Subscription } from 'rxjs';

import { BaseComponent } from '~Interfaces/basecomponent';

/**
 * Composant de message
 * @extends BaseComponent
 * @implements OnInit
 */
@Component({
  selector: 'app-message',
  templateUrl: './message.component.html',
  styleUrls: ['./message.component.scss']
})
export class MessageComponent extends BaseComponent implements OnInit {

    @Input() dureeAffichage: number = 0;
    messages: any[] = [];

    private subscription: Subscription = null;

    /**
     * Constructeur
     * @param messageService
     */
    constructor() {
        super();
    }

    /**
     * Initialisation du composant
     */
    ngOnInit() {
        // Inscription au service de message
        this.subscription = this.messageService.obtenirMessage().subscribe((message) => {
            if (message) {
                // R�cup�re le hash
                let hash = message.Hash;

                // V�rification si le message existe d�j�
                let messageExistant = this.messages.find((element) => {
                    return element.Hash == hash;
                });

                // Le message n'existe pas d�j�
                if (!messageExistant) {
                    // Ajoute le message au composant
                    this.messages.unshift(message);
                }
            }
        });
    }

    /**
     * Destruction du composant
     */
    ngOnDestroy() {
        // D�sincription au service de message
        this.subscription.unsubscribe();
    }

    /**
     * Supprimer un message
     * @param element
     */
    supprimer(element) {
        this.messages = this.messages.filter((e) => {
            return e.Hash != element.Hash;
        });
    }
}
